import { render, staticRenderFns } from "./goodsPackingAmount.vue?vue&type=template&id=6ec1daeb&"
import script from "./goodsPackingAmount.vue?vue&type=script&lang=js&"
export * from "./goodsPackingAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports